import { render, staticRenderFns } from "./KhPage.vue?vue&type=template&id=0df84422&scoped=true&"
import script from "./KhPage.vue?vue&type=script&lang=js&"
export * from "./KhPage.vue?vue&type=script&lang=js&"
import style0 from "./KhPage.vue?vue&type=style&index=0&id=0df84422&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df84422",
  null
  
)

export default component.exports